import { useAuth0Logout } from '@fortem-monorepo/react-spa'

import { getBaseURL } from '@/utilities/env'

export const useLogout = () => {
  return useAuth0Logout({ returnTo: `${getBaseURL()}/` })
}
